import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const PricesRequestFormDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  user: {},
};

export const PricesRequestFormPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  user: PropTypes.shape({ email: PropTypes.string }),
};
